/* bristm-hero — section script (loaded only where the section renders) */
(function () {
  if (window.BRISTM_HERO) return;
  window.BRISTM_HERO = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var active = new Set();
  var ticking = false;
  var listening = false;

  /* ---- Parallax / zoom on the showcase (transform only, rAF, visible-only) ---- */
  function update() {
    ticking = false;
    if (reduce.matches || !active.size) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var reads = [];
    active.forEach(function (el) {
      if (!el.isConnected) {
        active.delete(el);
        return;
      }
      reads.push([el, el.getBoundingClientRect()]);
    });
    reads.forEach(function (pair) {
      var r = pair[1];
      var media = pair[0].firstElementChild;
      if (!media) return;
      /* p: 0 when the frame's top enters the viewport bottom, 1 when its bottom leaves the top */
      var p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
      var scale = 1 + 0.05 * (1 - Math.min(p / 0.5, 1));
      var shift = (p - 0.5) * -70;
      media.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0) scale(' + scale.toFixed(4) + ')';
    });
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function setListening(on) {
    if (on === listening) return;
    listening = on;
    if (on) {
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request, { passive: true });
    } else {
      window.removeEventListener('scroll', request);
      window.removeEventListener('resize', request);
    }
  }

  var frameObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) active.add(entry.target);
            else active.delete(entry.target);
          });
          setListening(active.size > 0 && !reduce.matches);
          request();
        })
      : null;

  /* ---- Video: load + play only while visible ---- */
  var videoObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting && !reduce.matches) {
                if (v.preload === 'none') v.preload = 'auto';
                var pr = v.play();
                if (pr && pr.catch) pr.catch(function () {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          },
          { threshold: 0.15 }
        )
      : null;

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-b-hero-parallax]').forEach(function (el) {
      if (el.dataset.bBound) return;
      el.dataset.bBound = '1';
      if (frameObserver) frameObserver.observe(el);
    });
    scope.querySelectorAll('[data-b-hero-video]').forEach(function (v) {
      if (v.dataset.bBound) return;
      v.dataset.bBound = '1';
      if (videoObserver) videoObserver.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
